import { Button } from "@oc-labs/wt-storybook";
import { Link } from "react-router-dom";
import LinkParams from "../../../components/LinkParams";

export default function AuthLandingView() {
  return (
    <div className="px-6 py-12 flex flex-col justify-between items-center">
      <div className="w-full">
        <h1 className="text-[26px] mb-4 text-center capitalize text-gray-700">
          Operating real-world assets As scalable digital products
        </h1>
        <p className="text-slate-500 mb-8 text-center px-4">
          Create, issue, and operate digital assets without blockchain complexity.
        </p>
      </div>

      <div className="space-y-4 mx-6 flex flex-col mt-8 w-full">
        <LinkParams to="/auth/login">
          <Button type="primary">
            Log in
          </Button>
          </LinkParams>
          <LinkParams to="/auth/register">
          <Button type="tertiary">
            Create an account
          </Button>
        </LinkParams>
      </div>
    </div>
  );
}